import { seasonStateDefaults } from './season/season.models';
import { authStateDefaults } from '@oneapp/core/auth/auth.models';
import { leagueStateDefaults } from './league/league.models';
import { sportStateDefaults } from './sport/sport.models';
import { gamesStateDefaults } from '../games-and-eventing/games/games.models';
import { teamStateDefaults } from './team/team.models';
import { userStateDefaults } from './user/user.models';
import { usersStateDefaults } from '../user-management/users/users.models';
import { eventSearchesFiltersStateDefaults } from '../games-and-eventing/game/game-compare-xy/event-searches-filters.models';
import { compareXyStateDefaults } from '../games-and-eventing/game/game-compare-xy/game-compare-xy.models';
import { secondTierNavStateDefaults } from '../main/main.models';
import { trackingStateDefaults } from './tracking/tracking.models';
import { benchVerificationStateDefaults } from '../containers/oa-bench-verification/oa-bench-verification.models';
import { createGameStateDefaults } from '../games-and-eventing/game-creation/create-game/create-game.models';
import { venueStateDefaults } from './venue/venue.models';
import { createTrainingGameStateDefaults } from '../games-and-eventing/game-creation/create-training-game/create-training-game.models';
import { clearEventsStateDefaults } from '../containers/oa-clear-events/oa-clear-events.models';
import { playerInformationStateDefaults } from '../player-management/player-information/player-information.models';
import { taskEngineStateDefaults } from './task-engine/task-engine.models';
import { eventStateDefaults } from './event/event.models';
import { editGameStateDefaults } from '../games-and-eventing/game/game-edit/game-edit.models';
import { personGameHistoryStateDefaults } from '../player-management/player-game-history/player-game-history.models';
import { itemColorVerificationStateDefaults } from '../containers/oa-item-color-verification/oa-item-color-verification.models';
import { taskStatusStateDefaults } from '../task-status-dashboard/task-status/task-status.models';
import { resolveDuplicatesStateDefaults } from '../player-management/player-resolve-duplicates/player-resolve-duplicates.models';
import { countryStateDefaults } from './country/country.models';
import { workflowStateDefaults } from './workflow/workflow.models';
import { operationManagementSidepanelDefaults } from '../games-and-eventing/operation-management-console/operation-management-sidepanel/operation-management-sidepanel.models';
import { workflowNotesStateDefaults } from '../containers/oa-workflow-notes/oa-workflow-notes.models';
import { workflowLogStateDefaults } from '../containers/oa-workflow-logs/oa-workflow-log.models';
import { companyStateDefaults } from './company/company.models';
import { createUserStateDefaults } from '../user-management/user/create-user/create-user.models';
import { userGeneralInformationStateDefaults } from '../containers/oa-user-general-information/oa-user-general-information.models';
import { assessmentStateDefaults } from './assessment/assessment.models';
import { assignedAssessmentsStateDefaults } from '../training-and-assessments/assigned-assessments/assigned-assessments.models';
import { assessmentLibraryStateDefaults } from '../training-and-assessments/assessment-library/assessment-library.models';
import { assignAssessmentDialogStateDefaults } from '../training-and-assessments/assessment-library/assign-assessment-dialog/assign-assessment-dialog.models';
import { playerShiftVideosStateDefaults } from '../containers/oa-send-player-shifts/oa-send-player-shifts.models';
import { companyGeneralInformationStateDefaults } from '../containers/oa-company-general-information/oa-company-general-information.models';
import { editCompanyStateDefaults } from '../company-management/company/edit-company/edit-company.models';
import { operationManagementConsoleStateDefaults } from '../games-and-eventing/operation-management-console/operation-management-console.models';
import { moveEventsStateDefaults } from '../containers/oa-move-events/oa-move-events.models';
import { userSettingsStateDefaults } from './user-settings/user-settings.models';
import { videoCaptureStateDefaults } from '../video-capture-dashboard/video-capture/video-capture.models';
import { gameVideoStateDefaults } from '../games-and-eventing/game/game-video/game-video.models';
import { s3BucketStateDefaults } from '../file-manager/s3-bucket/s3-bucket.models';
import { fileExplorerStateDefaults } from '../containers/oa-file-explorer/oa-file-explorer.models';
import { venuesStateDefaults } from '../venue-management/venues/venues.models';
import { userRolesPermissionsStateDefaults } from '../user-management/user/user-roles-permissions/user-roles-permissions.models';
import { bundleStateDefaults } from './bundle/bundle.models';
import { editBundleStateDefaults } from '../bundle-management/edit-bundle/edit-bundle.models';
import { bundlesStateDefaults } from '../bundle-management/bundles/bundles.model';
import { teamsStateDefaults } from '../team-management/teams/teams.models';
import { companiesStateDefaults } from '../company-management/companies/companies.models';
import { leaguesStateDefaults } from '../league-management/leagues/leagues.models';
import { scheduleStateDefaults } from './schedule/schedule.models';
import { gamesScraperStateDefaults } from '../games-and-eventing/games-scraper/games-scraper.models';
import { bundleDetailsStateDefaults } from '../bundle-management/edit-bundle/bundle-details/bundle-details.models';
import { bundleIndividualGameStateDefaults } from '../bundle-management/edit-bundle/bundle-individual-games/bundle-individual-games.models';
import { editUserStateDefaults } from '../user-management/user/edit-user/edit-user.models';
import { nhlEdgeBackupStateDefaults } from '../nhl-edge-dashboard/nhl-edge-backup/nhl-edge-backup.models';
import { gamesInfoChangelogStateDefaults } from '../games-and-eventing/game-info-changelog/game-info-changelog.utils';
import { qaReportStateDefaults } from '../containers/oa-qa-report/oa-qa-report.utils';
import { gameStatusButtonStateDefaults } from '../containers/oa-game-status-button/oa-game-status-button.utils';
import { gameStateDefaults } from './game/game.utils';
import { rosterStateDefaults } from './roster/roster.utils';
import { personStateDefaults } from './person/person.utils';
import { gameRosterManagementStateDefaults } from '../games-and-eventing/game/game-roster-management/game-roster-management.utils';
import { gameCalibrationStateDefaults } from '../games-and-eventing/game/game-calibration/game-calibration.utils';
import { boxscoreStateDefaults } from '../containers/oa-boxscore/oa-boxscore.utils';

export const allStateSliceDefaults = [
    authStateDefaults,
    leagueStateDefaults,
    seasonStateDefaults,
    sportStateDefaults,
    teamStateDefaults,
    gameStateDefaults,
    rosterStateDefaults,
    gamesStateDefaults,
    personStateDefaults,
    qaReportStateDefaults,
    userStateDefaults,
    usersStateDefaults,
    compareXyStateDefaults,
    eventSearchesFiltersStateDefaults,
    secondTierNavStateDefaults,
    trackingStateDefaults,
    itemColorVerificationStateDefaults,
    benchVerificationStateDefaults,
    createGameStateDefaults,
    createTrainingGameStateDefaults,
    venueStateDefaults,
    clearEventsStateDefaults,
    playerInformationStateDefaults,
    personGameHistoryStateDefaults,
    editGameStateDefaults,
    taskEngineStateDefaults,
    eventStateDefaults,
    resolveDuplicatesStateDefaults,
    countryStateDefaults,
    taskStatusStateDefaults,
    gameRosterManagementStateDefaults,
    workflowStateDefaults,
    operationManagementSidepanelDefaults,
    workflowNotesStateDefaults,
    workflowLogStateDefaults,
    companyStateDefaults,
    createUserStateDefaults,
    userGeneralInformationStateDefaults,
    assessmentStateDefaults,
    assignedAssessmentsStateDefaults,
    assessmentLibraryStateDefaults,
    assignAssessmentDialogStateDefaults,
    playerShiftVideosStateDefaults,
    companyGeneralInformationStateDefaults,
    editCompanyStateDefaults,
    operationManagementConsoleStateDefaults,
    moveEventsStateDefaults,
    userSettingsStateDefaults,
    videoCaptureStateDefaults,
    gameVideoStateDefaults,
    fileExplorerStateDefaults,
    s3BucketStateDefaults,
    venuesStateDefaults,
    userRolesPermissionsStateDefaults,
    bundleStateDefaults,
    editBundleStateDefaults,
    bundlesStateDefaults,
    teamsStateDefaults,
    leaguesStateDefaults,
    companiesStateDefaults,
    scheduleStateDefaults,
    gamesScraperStateDefaults,
    bundleDetailsStateDefaults,
    bundleIndividualGameStateDefaults,
    editUserStateDefaults,
    nhlEdgeBackupStateDefaults,
    gamesInfoChangelogStateDefaults,
    gameStatusButtonStateDefaults,
    gameCalibrationStateDefaults,
    boxscoreStateDefaults
];
